import CategoryPageContainer from "../../../../Components/Applications/Ecommerce/CategoryPage/CategoryPageContainer";

const CategoryPage = () => {
  return <CategoryPageContainer />;
};

export default CategoryPage;
